import { Engine } from '../../core/Engine';
import { MoveCommand } from '../Commands';
import { Image } from '../../entities/Drawable/Image';

export class MoveCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: MoveCommand) {
        const obj = this.engine.find(command.uuid);
        obj?.transform.move(command.deltaPos);
        if (obj instanceof Image && obj.clipPath) {
            obj.clipPath?.transform.move(command.deltaPos);
        }
    }
}
